import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// 싱글톤 패턴으로 클라이언트를 한 번만 생성
let supabaseClient: any = null;

function getSupabaseClient() {
  if (!supabaseClient) {
    if (!supabaseUrl || !supabaseKey) {
      console.error('환경변수 상태:');
      console.error(
        'REACT_APP_SUPABASE_URL:',
        supabaseUrl ? '설정됨' : '미설정',
      );
      console.error(
        'REACT_APP_SUPABASE_ANON_KEY:',
        supabaseKey ? '설정됨' : '미설정',
      );
      throw new Error(
        'Supabase URL과 ANON KEY가 환경변수에 설정되지 않았습니다.',
      );
    }
    // console.log('Supabase 클라이언트 생성 중...');
    supabaseClient = createClient(supabaseUrl, supabaseKey);
  }
  return supabaseClient;
}

/**
 * supabase 클라이언트
 */
const supabase = getSupabaseClient();

export default supabase;
